import React from 'react';
import ActionDialog from 'jd-library/ActionDialog';
import NoResultFound from './NoResultFound';
import './not-found-modal.scss';
import Button from 'jd-library/Button';
import { hideNotFoundModal, updateEditProductDetail, getProductData } from '../../actions/products';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

const NotFoundModal = props => {
    const history = useHistory();

    const createNewProd = () => {
        props.hideNotFoundModal();
        setTimeout(() => {
         props.updateEditProductDetail([{
             key: 'barcode',
             value: props.barcode
         },{
            key: "productId",
            value: "ADD_PRODUCT"
         },{
            key: "imageUrlArr",
            value: [],
          },
          {
            key: "videoUrlArr",
            value: [],
          },
          {
            key: "videoUrlIds",
            value: [],
          }])   
          history.push('/products/add?isTemp=true');
        },300);
    }
    const component = (
        <div className={''}>
            <NoResultFound dontShowText={true} />
            <div className='title'>Product Not Found</div>
            <div className='desc'>{`
                We cannot find a product in the library with the scanned barcode. You can
                create a new custom product.
            `}</div>
            <Button className={'create-btn'} children={'Create New Product'} clickHandler={createNewProd}/>
            <Button className={'cancel-btn'} clickHandler={() => {
                props.hideNotFoundModal();
                props.closeCB();
            }} children={'Cancel'} variant={'default'} />
        </div>
    );
    return (
    <ActionDialog
        settings={{
        modalId: 'not-found-modal',
        variant: 'action',
        class: `not-found-modal`
        }}
        backdropStatic={true}
        onHidden={() => {
            props.hideNotFoundModal();
            props.closeCB();
        }}
        title={''}
        content={component}
    />
    )
};

export default connect(null,{hideNotFoundModal,updateEditProductDetail, getProductData})(NotFoundModal);
